import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5egcvgxh5v: FaireBrandEntity = {
  token: "b_5egcvgxh5v",
  type: "brand",
  name: "katora jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/1587c9d7f6795a7934d4378cb49d300747b7b196ffd34d49a381ab6c273f9172.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d93ab1878de9c7aed72667ba756fd7aa02396b3febfd06b23725ff7ed77dfd1b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1587c9d7f6795a7934d4378cb49d300747b7b196ffd34d49a381ab6c273f9172.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d93ab1878de9c7aed72667ba756fd7aa02396b3febfd06b23725ff7ed77dfd1b.jpeg",
  location: "Warwick, RI, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 9,
  isInsider: true,
  description:
    "Katherine De Tora is the\ndesigner of katora jewelry\nwhich is a Rhode Island\nbased company. Most of\nthe jewelry's component\nparts come from businesses\nin RI. All the stones in\nkatora jewelry are\nAustrian crystals and\nmost are set by hand.\nAll pieces are made from a\nbrass base that is\nelectroplated in either\nimitation rhodium or in an\n14k gold color that is\nfinished with anti-tarnish\nThe plating is 100% lead and\nnickel free. The post on\nearrings are made from\nsurgical steal.\nPackaging (pictured above)\nis included for each\nindividual item. The cost is\nbuilt into each jewelry\npieces wholesale price.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:56.251Z",
    importedBy: "entity-db-cli",
  },
};
